module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('instamapsBreadcrumbs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasBreadcrumbs),
      expression: "hasBreadcrumbs"
    }],
    attrs: {
      "title": _vm.$t('title')
    }
  }), _vm._v(" "), _c('div', [_c('instamapsPerfilFeatured', {
    attrs: {
      "availableMaps": _vm._availableMaps,
      "lastActivity": _vm._lastActivity,
      "selectedLang": _vm.selectedLang,
      "user": _vm.user
    }
  }), _vm._v(" "), _c('instamapsPerfilList', {
    attrs: {
      "selectedLang": _vm.selectedLang,
      "mapaBorrar": _vm.mapaBorrar,
      "appBorrar": _vm.appBorrar,
      "refresh": _vm.refreshMaps,
      "mapaVisibilitat": _vm.mapaVisibilitat,
      "user": _vm.user,
      "socPropietari": _vm.socPropietari
    },
    on: {
      "loading": function($event) {
        _vm.loading()
      },
      "loaded": function($event) {
        _vm.loaded($event)
      },
      "borrarMapa": _vm.showModalBorrar,
      "borrarColaboradorMapa": _vm.showModalBorrarColaborador,
      "borrarApp": _vm.showModalBorrarApp,
      "duplicarMapa": _vm.showModalDuplicar,
      "compartirMapa": _vm.showModalCompartir,
      "colaborarMapa": _vm.showModalColabora,
      "logout": _vm.userLogout,
      "canviarVisibilitatMapa": _vm.showModalVisibilitat,
      "crearUsuarisMapa": _vm.showModalCrearUsuari
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "extra-bottom-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showModalPassword
    }
  }, [_vm._v(_vm._s(_vm.$t('cambiarPssw')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showModalBaja
    }
  }, [_vm._v(_vm._s(_vm.$t('deleteAccount')))])])])])], 1), _vm._v(" "), _c('instamapsBorrarModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalBorrarIsLoaded,
      "mapa": _vm.currentMapa,
      "isLoadedColaborar": _vm.modalBorrarColaboradorIsLoaded
    },
    on: {
      "loaded": _vm.loadedBorrar,
      "deleteMap": _vm.esborrarMapa,
      "error": _vm.showModalError,
      "deleteColaborator": _vm.duplicarMapa
    }
  }), _vm._v(" "), _c('instamapsBorrarAppModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalBorrarAppIsLoaded,
      "mapa": _vm.currentMapa
    },
    on: {
      "loaded": _vm.loadedBorrarApp,
      "deleteApp": _vm.esborrarApp,
      "error": _vm.showModalError
    }
  }), _vm._v(" "), _c('instamapsDuplicarModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalDuplicarIsLoaded,
      "mapa": _vm.currentMapa
    },
    on: {
      "loaded": _vm.loadedDuplicar,
      "copyMap": _vm.duplicarMapa,
      "error": _vm.showModalError
    }
  }), _vm._v(" "), _c('instamapsCompartirModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalCompartirIsLoaded,
      "mapa": _vm.currentMapa
    },
    on: {
      "loaded": _vm.loadedCompartir,
      "error": _vm.showModalError
    }
  }), _vm._v(" "), _c('instamapsColaboraModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalColaboraIsLoaded,
      "mapa": _vm.currentMapa
    },
    on: {
      "loaded": _vm.loadedColabora,
      "error": _vm.showModalError
    }
  }), _vm._v(" "), _c('instamapsCambiarPasswordModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalCambiarPasswordIsLoaded
    },
    on: {
      "loaded": _vm.loadedCambiarPassword,
      "error": _vm.showModalError,
      "ok": _vm.showModalOk
    }
  }), _vm._v(" "), _c('instamapsBajaModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalBajaIsLoaded
    },
    on: {
      "loaded": _vm.loadedBaja,
      "deleteUser": _vm.bajaUsuario,
      "error": _vm.showModalError
    }
  }), _vm._v(" "), _c('instamapsMessageModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalIsLoaded,
      "title": _vm.modalTitle,
      "message": _vm.modalMessage
    },
    on: {
      "loaded": _vm.loadedMessage
    }
  }), _vm._v(" "), _c('instamapsVisibilitatModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalVisibilitatIsLoaded,
      "mapa": _vm.currentMapa,
      "title": _vm.modalTitle,
      "message": _vm.modalMessage
    },
    on: {
      "loaded": _vm.loadedVisibilitat,
      "visibilitatMapOK": _vm.changeVisibility
    }
  }), _vm._v(" "), _c('instamapsCrearUsuarisModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalCrearUsuarisIsLoaded,
      "mapa": _vm.currentMapa,
      "title": _vm.modalTitle,
      "message": _vm.modalMessage
    },
    on: {
      "loaded": _vm.loadedCrearUsuaris,
      "derivatsMap": _vm.derivatsMapa
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52dadb3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/perfil/perfil.vue
// module id = 307
// module chunks = 0